import React from 'react';
import { NetworkLinks } from 'mm-ui-components';
import { useSelector } from 'react-redux';
import { getNetworkLinks } from '../../store/navigations/navigation/networkLinks/networkLinks.selector';

export const NetworkLinksConnected = () => {
    const networkLinks = useSelector(getNetworkLinks);
    return networkLinks && networkLinks.links.length !== 0 ? <NetworkLinks {...networkLinks} /> : null;
};
